/**
 * localStorage兼容性检测和fallback机制
 * 解决平板浏览器localStorage不可用的问题
 */

// 内存存储fallback
let memoryStorage = {}

/**
 * 检测localStorage是否可用
 */
export function isLocalStorageAvailable() {
  try {
    const test = '__localStorage_test__'
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
}

/**
 * 安全的存储操作
 */
export const safeStorage = {
  /**
   * 设置存储项
   */
  setItem(key, value) {
    try {
      if (isLocalStorageAvailable()) {
        localStorage.setItem(key, value)
      } else {
        // 使用内存存储作为fallback
        memoryStorage[key] = value
        console.warn('localStorage不可用，使用内存存储作为fallback')
      }
    } catch (error) {
      console.error('存储设置失败:', error)
      memoryStorage[key] = value
    }
  },

  /**
   * 获取存储项
   */
  getItem(key) {
    try {
      if (isLocalStorageAvailable()) {
        return localStorage.getItem(key)
      } else {
        // 从内存存储获取
        return memoryStorage[key] || null
      }
    } catch (error) {
      console.error('存储读取失败:', error)
      return memoryStorage[key] || null
    }
  },

  /**
   * 移除存储项
   */
  removeItem(key) {
    try {
      if (isLocalStorageAvailable()) {
        localStorage.removeItem(key)
      }
      // 同时清除内存存储
      delete memoryStorage[key]
    } catch (error) {
      console.error('存储删除失败:', error)
      delete memoryStorage[key]
    }
  },

  /**
   * 清空所有存储
   */
  clear() {
    try {
      if (isLocalStorageAvailable()) {
        localStorage.clear()
      }
      // 清空内存存储
      memoryStorage = {}
    } catch (error) {
      console.error('存储清空失败:', error)
      memoryStorage = {}
    }
  },

  /**
   * 获取存储类型
   */
  getStorageType() {
    return isLocalStorageAvailable() ? 'localStorage' : 'memoryStorage'
  },

  /**
   * 获取所有存储的键值对（用于调试）
   */
  getAllItems() {
    const items = {}
    try {
      if (isLocalStorageAvailable()) {
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i)
          items[key] = localStorage.getItem(key)
        }
      } else {
        Object.assign(items, memoryStorage)
      }
    } catch (error) {
      console.error('获取存储项失败:', error)
      Object.assign(items, memoryStorage)
    }
    return items
  }
}

/**
 * 存储状态检测
 */
export function getStorageStatus() {
  const status = {
    localStorage: isLocalStorageAvailable(),
    storageType: safeStorage.getStorageType(),
    itemCount: 0,
    items: {}
  }

  try {
    status.items = safeStorage.getAllItems()
    status.itemCount = Object.keys(status.items).length
  } catch (error) {
    console.error('获取存储状态失败:', error)
  }

  return status
}